<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <!-- <BigButton text="View Fact Sheet" /> -->
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />

        <div @click="toggleDialog" style="cursor:pointer">
          <v-img src="https://streetcar-east.s3.us-east-2.amazonaws.com/irwin_detour_map.jpg" contain style="height:60vh" />
        </div>
        <v-img src="../../public/static/Easel Bottom.png" :width="easelBottom" />
      </v-col>
      <v-col :cols="columns">
        <v-card class="slide-card" style="max-width: 90%; max-height: 85vh; overflow-y: auto;">
          <div class="slide-content">
            <h1 id="header">What is the Irwin Street Traffic Study?</h1>
            <p>
              Irwin Street/Lake Avenue at the BeltLine between Krog Street and Auburn Avenue/Sampson Street was closed
              to vehicular traffic November 7 - 13, 2022. MARTA, the City of Atlanta’s Department of Transportation
              (ATLDOT) and Atlanta BeltLine, Inc. (ABI) conducted a traffic study during the 667 Auburn development
              closure to evaluate impacts to surrounding neighborhoods and businesses for the Streetcar East Extension
              project.

            </p>
            <p>Please see the project update sheet for additional information.</p>

            <p>The study allowed the project team to collect trip data to inform design decisions. It also allowed the
              community to provide feedback on the permanent closure of Irwin Street at the BeltLine. The survey closed
              December 7, 2022 and results will be posted in early 2022.
            </p>
            <p>
              Please contact project manager, Bryan Hobbs at jhobbs@itsmarta.com if you have any questions or comments.
              You can also contact MARTA’s Customer Call Center at 404-848-5000 with additional questions.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- <ImagePopup v-if="toggled" :close-modal="toggleDialog"
      image="https://streetcar-east.s3.us-east-2.amazonaws.com/projectHistory.png" /> -->
    <ImagePopup v-if="toggledFAQ" :close-modal="toggleDialogFAQ"
      image="https://streetcar-east.s3.us-east-2.amazonaws.com/projectInfo.jpg" />
  </v-sheet>
</template>

<script>
import ImagePopup from "@/components/ImagePopup.vue";
// import BigButton from "@/components/BigButton.vue";

export default {
  name: "IrwinStreetTrafficStudy",
  components: {
    ImagePopup
    // BigButton
  },
  data() {
    return {
      toggled: false,
      toggledFAQ: false,
      factSheetUrl:
        "https://streetcar-east.s3.us-east-2.amazonaws.com/projectInfo.jpg"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleDialog() {
      this.toggled = !this.toggled;
    },
    toggleDialogFAQ() {
      this.toggledFAQ = !this.toggledFAQ;
    }
  }
};
</script>

<style scoped>
/* p {
  font-size: 12pt !important;
} */

.myButton {
  box-shadow: 0px 1px 0px 0px #f0f7fa;
  background: linear-gradient(to bottom, #33bdef 5%, #019ad2 100%);
  background-color: #33bdef;
  border-radius: 15px;
  border: 1px solid #057fd0;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  text-shadow: 0px -1px 0px #5b6178;
  text-transform: uppercase;
}

.myButton:hover {
  background: linear-gradient(to bottom, #019ad2 5%, #33bdef 100%);
  background-color: #019ad2;
}

.myButton:active {
  position: relative;
  top: 1px;
}
</style>
